module.exports = __webpack_public_path__ + "static/media/cleanlife.bf45f892.png";